// Type definitions for MoveProcess (Flytteplan) — matches backend DTOs.

export enum MoveProcessStatus {
    Draft = 0,
    Planned = 10,
    Executing = 20,
    Completed = 30,
    Cancelled = 40
}

export enum MoveProcessStepStatus {
    Pending = 0,
    Reserved = 10,
    Executed = 20,
    Failed = 30,
    Skipped = 40
}

export const MOVE_PROCESS_STATUS_LABELS: Record<MoveProcessStatus, string> = {
    [MoveProcessStatus.Draft]: 'Kladd',
    [MoveProcessStatus.Planned]: 'Planlagt',
    [MoveProcessStatus.Executing]: 'Under utførelse',
    [MoveProcessStatus.Completed]: 'Ferdig',
    [MoveProcessStatus.Cancelled]: 'Avbrutt'
};

export const MOVE_PROCESS_STEP_STATUS_LABELS: Record<MoveProcessStepStatus, string> = {
    [MoveProcessStepStatus.Pending]: 'Venter',
    [MoveProcessStepStatus.Reserved]: 'Reservert',
    [MoveProcessStepStatus.Executed]: 'Utført',
    [MoveProcessStepStatus.Failed]: 'Feilet',
    [MoveProcessStepStatus.Skipped]: 'Hoppet over'
};

export interface MoveProcessStep {
    id: number;
    moveProcessId: number;
    stepOrder: number;
    fromBinCode: string;
    toBinCode: string;
    itemNo: string;
    quantity: number;
    batchNo?: string;
    serialNo?: string;
    status: number;
    dependsOnStepId?: number;
    executedStcOrderNo?: number;
    incomingReservationId?: number;
    errorMessage?: string;
}

export interface MoveProcess {
    id: number;
    warehouseID: string;
    name: string;
    description?: string;
    status: number;
    scheduledFor?: string;
    createdBy?: string;
    created?: string;
    stepCount: number;
    completedStepCount: number;
    steps: MoveProcessStep[];
}

export interface CreateMoveProcessRequest {
    warehouseID: string;
    name: string;
    description?: string;
    scheduledFor?: string;
}

export interface UpdateMoveProcessRequest {
    name?: string;
    description?: string;
    scheduledFor?: string;
    status?: number;
}

export interface AddMoveProcessStepRequest {
    fromBinCode: string;
    toBinCode: string;
    itemNo: string;
    quantity: number;
    batchNo?: string;
    serialNo?: string;
}

export interface UpdateMoveProcessStepRequest {
    fromBinCode?: string;
    toBinCode?: string;
    itemNo?: string;
    quantity?: number;
    batchNo?: string;
    serialNo?: string;
    stepOrder?: number;
}

export interface AddStepsBatchRequest {
    steps: AddMoveProcessStepRequest[];
}

export interface AddStepsBatchResponse {
    success: boolean;
    errorMessage?: string;
    createdSteps: MoveProcessStep[];
    successCount: number;
    failedCount: number;
}

export interface StepDependency {
    stepId: number;
    dependsOnStepId: number;
    reason: string;
}

export interface ValidateMoveProcessResponse {
    canExecute: boolean;
    errors: string[];
    warnings: string[];
    dependencies: StepDependency[];
}

export interface ExecuteMoveProcessResponse {
    success: boolean;
    errorMessage?: string;
    processId: number;
    executedStepCount: number;
    failedStepCount: number;
    steps: MoveProcessStep[];
    stcOrderNumbers: number[];
}
